import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../../../src/environments/environment';
import { AuthService } from '../../../../../src/app/core/auth/services/auth.service';

@Pipe({
  name: 'secureImage'
})
export class SecureImagePipe implements PipeTransform {
  constructor(
    private http: HttpClient, 
    private sanitizer: DomSanitizer,
    private authService: AuthService
  ) {}

  transform(url: string): Observable<SafeUrl | string> {
    if (!url) {
      return of('assets/images/profile_placeholder.png');
    }

    if (!this.authService.getToken()) {
      return of('assets/images/profile_placeholder.png');
    }

    if (url.startsWith('data:') || url.startsWith('assets') || url.startsWith('./assets')) {
      return of(url);
    }

    let cleanPath = url;
    if (url.startsWith('/v1')) {
        cleanPath = url.substring(3);
    }
    const finalUrl = url.startsWith('http') ? url : `${environment.api_url}${cleanPath}`;

    return this.http
      .get(finalUrl, { responseType: 'blob' })
      .pipe(
        map((blob: Blob) => {
          const objectURL = URL.createObjectURL(blob);
          return this.sanitizer.bypassSecurityTrustUrl(objectURL);
        }),
        catchError(() => of('assets/images/profile_placeholder.png'))
      );
  }
}
